// Remaining-time estimate for the paged CSV export: average duration of the
// completed pages extrapolated over the pages still to fetch. Returns null
// until at least one page has completed (no basis for an estimate yet).
export const computeRemainingSeconds = (
    pagesDone: number,
    pagesTotal: number,
    elapsedMs: number
): number | null => {
    if (pagesDone <= 0 || pagesTotal <= 0 || elapsedMs < 0) return null;
    const remainingPages = Math.max(0, pagesTotal - pagesDone);
    const avgPageMs = elapsedMs / pagesDone;
    return Math.round((remainingPages * avgPageMs) / 1000);
};

// "~5 min" / "~45 s" style label for the snackbar detail line.
export const formatRemainingTime = (seconds: number): string => {
    if (seconds < 60) {
        return `~${Math.max(seconds, 1)} s`;
    }
    return `~${Math.round(seconds / 60)} min`;
};
